// extracted by mini-css-extract-plugin
export default {"main":"LinkButton_main__dH1cX","icon":"LinkButton_icon__2zm0h","disabled":"LinkButton_disabled__XuY3V"};